<script>
import carousel from 'vue-owl-carousel';
import moment from 'moment';

import { trainerComputed, homeComputed, authComputed, homeMethods } from '@state/helpers';

import CardWorkoutHome from '@components/cards/card-workout-home.vue';
import SayHelloMobile from '@views/home/mobile/say-hello-mobile.vue';

export default {
  name: 'ScrollLbs',
  components: { carousel, CardWorkoutHome, SayHelloMobile },
  props: {},
  data() {
    return {
      todaysDate: moment().format('MMM Do'),
      placeholder: require('@assets/images/placeholder-avatar.png'),
      isSliding: false,
    };
  },
  beforeMount() {},
  mounted() {},
  computed: {
    ...trainerComputed,
    ...homeComputed,
    ...authComputed,
    trainerAvatar() {
      return this.myTrainer &&
        this.myTrainer.mediaAssets &&
        this.myTrainer.mediaAssets.avatarImage &&
        this.myTrainer.mediaAssets.avatarImage.url
        ? this.myTrainer.mediaAssets.avatarImage.url
        : this.placeholder;
    },
    metrics() {
      return this.progressDetails && this.progressDetails.metrics;
    },
    progressHours() {
      return this.metrics && this.metrics.totalWorkoutDurationSeconds
        ? (this.metrics.totalWorkoutDurationSeconds / 3600).toFixed(1)
        : 0;
    },
    workoutOptions() {
      return this.homeOverview && this.homeOverview.workoutOptions;
    },
    currentWeekNumber() {
      return this.homeOverview && this.homeOverview.weekNumber;
    },
    currentWeek() {
      return (
        this.progressDetails &&
        this.progressDetails.weeks &&
        this.progressDetails.weeks.length > 0 &&
        this.progressDetails.weeks.find((week) => week.weekNumber === this.currentWeekNumber)
      );
    },
    workoutsOfWeek() {
      if (this.homeOverview && this.homeOverview.isProgramEmpty) {
        return [{}]; // render one card to display empty program status
      } else {
        return this.currentWeek.days.map((day) => {
          if (this.homeOverview.workoutOptions && this.homeOverview.workoutOptions.length > 0) {
            return this.homeOverview.workoutOptions.find((workout) => workout.dayNumber === day.dayNumber);
          }
        });
      }
    },
    dayNumber() {
      return moment().day();
    },
    cssVars() {
      return {
        '--gradient': process.env.VUE_APP_ORG_ID === '618183d65e84466f63c38878'?
        'linear-gradient(93.14deg, #ff9f9c -31.06%, #ff6e69 125.68%)' :
        'linear-gradient(93.14deg, #55bcf5 -31.06%, #3e4fe2 125.68%)'
      }
    }
  },
  methods: {
    ...homeMethods,
    updated(e) {
      if (e.type === 'translated') {
        this.isSliding = false;
      } else {
        this.isSliding = true;
      }
    },
    toProgress() {
      this.setIsLoadingProgress(true);
      this.$router.push({ name: 'progress' });
    },
  },
};
</script>

<template>
  <div class="workout-details-container" :style="cssVars">
    <b-col>
      <div class="date">
        <span>{{ todaysDate }}</span>
        <div v-if="homeOverview && homeOverview.checkInNeedingClientInput" @click="$bvModal.show('checkin-modal')">
          <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M14.875 0.125H2.125C0.929688 0.125 0 1.08789 0 2.25V11.8125C0 13.0078 0.929688 13.9375 2.125 13.9375H5.3125V16.7266C5.3125 17.0586 5.67773 17.2578 5.94336 17.0586L10.0938 13.9375H14.875C16.0371 13.9375 17 13.0078 17 11.8125V2.25C17 1.08789 16.0371 0.125 14.875 0.125ZM8.5 11.2812C7.90234 11.2812 7.4375 10.8164 7.4375 10.2188C7.4375 9.6543 7.90234 9.15625 8.5 9.15625C9.06445 9.15625 9.5625 9.6543 9.5625 10.2188C9.5625 10.8164 9.06445 11.2812 8.5 11.2812ZM9.33008 7.62891C9.29688 7.89453 9.06445 8.09375 8.79883 8.09375H8.16797C7.90234 8.09375 7.66992 7.89453 7.63672 7.62891L7.20508 3.37891C7.17188 3.08008 7.4375 2.78125 7.73633 2.78125H9.23047C9.5293 2.78125 9.79492 3.08008 9.76172 3.37891L9.33008 7.62891Z"
              fill="#4059E1"
            />
          </svg>
          Complete Your Check-In
        </div>
      </div>
    </b-col>
    <carousel
      :autoplay="false"
      :nav="false"
      :center="true"
      :dots="false"
      :items="20"
      :autoWidth="true"
      @changed="updated"
      @updated="updated"
      @initialize="updated"
      @initialized="updated"
      @resize="updated"
      @resized="updated"
      @refresh="updated"
      @refreshed="updated"
      @update="updated"
      @drag="updated"
      @dragged="updated"
      @translate="updated"
      @translated="updated"
      @to="updated"
      ref="carousel"
      :startPosition="dayNumber - 1"
    >
      <template v-for="(workoutOption, i) in workoutsOfWeek">
        <div :key="i" class="workout-details">
          <CardWorkoutHome :isSliding="isSliding" :workout="workoutOption" />
        </div>
      </template>
    </carousel>
    <div v-if="homeOverview && homeOverview.todaysTrainerNote" class="row trainer-notification">
      <div class="col-4 avatar-wrapper">
        <img :src="trainerAvatar" />
      </div>
      <div class="col note-wrapper">
        <div class="note">
          <p>{{ homeOverview.todaysTrainerNote }}</p>
        </div>
      </div>
    </div>
    <SayHelloMobile v-if="homeOverview && homeOverview.isProgramEmpty" />
    <div @click.stop="toProgress" v-if="homeOverview && !homeOverview.isProgramEmpty" class="progress-program-completion">
      <span class="icon-arrow-wrapper" @click.stop="toProgress">
        <BaseIcon class="icon-arrow" name="arrow-right" />
      </span>
      <div class="content">
        <div class="title"><p>Your Progress</p></div>
        <div class="row">
          <div class="col">
            <div class="num">
              {{ metrics && metrics.workoutsCompleted ? metrics.workoutsCompleted : 0 }}
            </div>
            <span>WORKOUTS</span>
          </div>
          <span class="divider-vertical">&nbsp;</span>
          <div class="col">
            <div class="num">
              {{ metrics && metrics.exercisesCompleted ? metrics.exercisesCompleted : 0 }}
            </div>
            <span>EXERCISES</span>
          </div>
          <span class="divider-vertical">&nbsp;</span>
          <div class="col">
            <div class="num">
              {{ progressHours }}
            </div>
            <span>HOURS</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-pseudo-element-no-unknown

.progress-program-completion {
  align-items: center;
  background: var(--gradient);
  border-radius: 8px;
  color: white;
  display: flex;
  flex: 1;
  flex-direction: column;
  font-size: 11px;
  font-style: normal;
  font-weight: 800;
  justify-content: center;
  letter-spacing: 0.0916667px;
  line-height: 22px;
  margin-bottom: 2.3rem;
  margin-left: 2rem;
  margin-right: 2rem;
  position: relative;
  text-transform: uppercase;
  .icon-arrow-wrapper {
    height: 15px;
    position: absolute;
    right: 25px;
    top: 20px;
    width: 15px;
    svg {
      height: 100%;
      width: 100%;
    }
  }
  .content {
    max-width: 60rem;
    padding: 2rem;
    width: 89vw;
  }
  .title {
    align-items: center;
    align-self: flex-start;
    color: #fff;
    display: flex;
    font-family: $secondary-font-family;
    font-size: 16px;
    font-style: normal;
    font-weight: 900;
    justify-content: space-between;
    line-height: 19px;
    padding-bottom: 2rem;
    position: relative;
    text-transform: capitalize;
    p {
      @include calc-font-size(1.7);

      align-items: center;
      color: #fff;
      display: flex;
      font-family: $secondary-font-family;
      font-style: normal;
      font-weight: 600;
      line-height: 19px;
      margin-bottom: unset;
      text-transform: capitalize;
    }
  }

  .row {
    align-items: center;
    display: flex;
    justify-content: space-evenly;
    max-width: 60rem;
    .col {
      align-items: flex-start;
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: relative;
    }
  }
  a {
    text-decoration-color: black;
  }

  .program-completion-percentage {
    color: $color-heading-text;
    font-size: 1.8rem;
    letter-spacing: 0.16429px;
    line-height: 5rem;
    margin: 0 0 0 1.6rem;

    small {
      color: $color-medium-gray-alt;
      display: block;
      font-size: 1.1rem;
      font-weight: 800;
      letter-spacing: 0.0916667px;
      line-height: 0;
      text-transform: uppercase;

      &.percent-symbol {
        color: $color-heading-text;
        display: initial;
      }
    }
  }
  .divider-vertical {
    border-left: 1px solid rgba(#fff, 0.6);
    height: 4.7rem;
    opacity: 0.4;
  }
  .num {
    @include calc-font-size(3.3);

    margin-bottom: 0.5rem;
  }
  span {
    @include calc-font-size(1.1);

    opacity: 0.8;
  }

  .icon-chevron-wrapper {
    background-color: $color-medium-gray;
    border-radius: 50%;
    bottom: 0;
    display: flex;
    height: 3.2rem;
    justify-content: center;
    overflow: hidden;
    position: absolute;
    right: 0;
    width: 3.2rem;

    &:hover {
      cursor: pointer;
    }
  }
}

.trainer-notification {
  align-items: center;
  flex-direction: row;
  flex-wrap: unset;
  margin-bottom: 2.3rem;
  margin-left: unset;
  margin-left: 2rem;
  margin-right: unset;
  margin-right: 2rem;
  max-width: 65rem;
  width: 89vw;
  .note-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: start;
    p {
      line-height: 2.1rem;
    }
  }
  .avatar-wrapper {
    align-items: flex-start;
    display: flex;
    max-width: fit-content;
    img {
      border-radius: 50%;
      height: 6.5rem;
      object-fit: cover;
      width: 6.5rem;
    }
  }
}

.workout-details-container {
  height: fit-content;
  padding: 2rem 0 0 0;
  padding-top: unset;
  position: relative;
  .col-sm-12 {
    align-items: center;
    display: flex;
    justify-content: flex-start;
    margin-left: 2rem;
    margin-right: 2rem;
  }
  .workout-details {
    width: 89vw;
    ::v-deep .start-workout-card {
      min-height: unset;
      &::after {
        min-height: unset;
      }
      .start-workout {
        bottom: -23px;
        min-height: 45px;
        right: 8%;
        width: 50%;
        p {
          padding-left: 1rem;
          padding-right: 1rem;
        }
      }
      #class {
        font-size: calc(2.2rem + (21 - 16) * ((100vw - 30rem) / (1600 - 300)));
      }
    }
  }
  ::v-deep .owl-stage-outer {
    display: flex;
    justify-content: flex-start;
    padding-bottom: 5rem !important;
    padding-top: 1rem !important;
    right: 8px;
  }
  ::v-deep .owl-stage {
    height: 26vh;
  }

  ::v-deep .owl-item {
    transition: all 0.25s ease-in-out;
    .workout-details {
      height: 20vh;
      transition: height 0.25s;
    }
    &.active {
      .workout-details {
        padding-right: 0;
      }
    }
    &.center {
      margin-left: 12px !important;
      margin-right: 12px !important;
      .workout-details {
        height: 26vh;
      }
    }
    &:not(.center) {
      height: 95%;
    }
  }
  .date {
    align-items: center;
    display: flex;
    justify-content: space-between;
    width: 100%;
    span {
      align-items: center;
      color: #000;
      display: flex;
      font-family: 'Roboto', serif;
      font-size: calc(2.2rem + (21 - 16) * ((100vw - 30rem) / (1600 - 300)));
      font-style: normal;
      font-weight: 900;
      line-height: 30px;
      margin-left: 0%;
      text-transform: capitalize;
      white-space: nowrap;
    }
    div {
      color: #4059e1;
      cursor: pointer;
      float: right;
      font-size: 17px;
      font-style: normal;
      font-weight: bold;
      line-height: 23px;
      margin-left: 5px;
      text-align: center;
      white-space: nowrap;
      svg {
        margin-right: 5px;
      }
    }
  }
}

.owl-carousel {
  width: 100%;
}
</style>
